import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import {
  IShopProductItem,
  TShopAssociatedProductsQueryVariables,
  TShopAssociation,
  TShopAssociationsQueryVariables,
  TShopAssociationsWithProductsQueryVariables,
  TShopAssociationWithProducts,
} from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';
import {
  ShopAssociatedProductsGQL,
  ShopAssociationsGQL,
  ShopAssociationsWithProductsGQL,
} from './gql/shop-associations.gql.generated';

@Injectable()
export class ShopAssociationsService {
  constructor(
    private readonly shopAssociatedProductsGQL: ShopAssociatedProductsGQL,
    private readonly shopAssociationsWithProductsGQL: ShopAssociationsWithProductsGQL,
    private readonly shopAssociationsGQL: ShopAssociationsGQL,
  ) {}

  fetchAssociationsWithProducts$(
    query: TShopAssociationsWithProductsQueryVariables,
  ): Observable<TShopAssociationWithProducts[]> {
    return this.shopAssociationsWithProductsGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopAssociations));
  }

  fetchAssociatedProducts$(
    query: TShopAssociatedProductsQueryVariables,
  ): Observable<IShopProductItem[]> {
    return this.shopAssociatedProductsGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopAssociatedProducts));
  }

  fetchAssociations$(query: TShopAssociationsQueryVariables): Observable<TShopAssociation[]> {
    return this.shopAssociationsGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopAssociations));
  }
}
